
export enum VideoEventRisk {
    None,
    Low,
    Medium,
    High,
    Urgent
}
